module.exports = __webpack_public_path__ + "45f51a96673bcbb3bde6d553e65a31d0.svg";